import { useEffect, useState } from 'react';
import api from '../api/endpoints';
import ImageUploader from './ImageUploader';
import { Chip, Input } from './Ui';

/** First required question left unanswered, or null. */
export const missingRequired = (fields, answers) => {
  const f = (fields || []).find((q) => {
    if (!q.required) return false;
    const a = answers[q.key];
    if (q.kind === 'file') return !((a && a.files) || []).length;
    return !String((a && a.value) ?? '').trim();
  });
  return f ? f.label : null;
};

/**
 * The questions admin set up for this kind of partner - a driving licence and
 * RC for riders, a certificate for a salon - rendered from the server's list.
 * `answers` is { [key]: { value, files } }.
 */
const OnboardingQuestions = ({
  partnerType, categories = [], answers, onChange, onFields,
  form = 'partner',
  fields: given,           // already fetched by the parent - then we do not fetch
}) => {
  const [fields, setFields] = useState(given || []);
  const catKey = categories.join(',');

  useEffect(() => { if (given) setFields(given); }, [given]);
  useEffect(() => {
    if (given) return;
    if (form === 'partner' && !partnerType) { setFields([]); if (onFields) onFields([]); return; }
    api.onboarding.fields({ form, partnerType, categories: catKey })
      .then((r) => { setFields(r.data || []); if (onFields) onFields(r.data || []); })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerType, catKey, form, given]);

  const questions = fields.filter((f) => f.kind !== 'builtin');
  if (!questions.length) return null;
  const set = (key, patch) => onChange({ ...answers, [key]: { ...(answers[key] || {}), ...patch } });

  return (
    <div style={{ marginTop: 18, paddingTop: 16, borderTop: '1px solid var(--line)' }}>
      {form === 'partner' ? (
        <>
          <h3 className="h3">Documents &amp; details</h3>
          <div className="t-tiny" style={{ marginBottom: 10 }}>KAAMWALA checks these before approving your account.</div>
        </>
      ) : null}
      {questions.map((f) => {
        const a = answers[f.key] || {};
        const label = `${f.label}${f.required ? ' *' : ''}`;
        if (f.kind === 'file') {
          return (
            <ImageUploader key={f.key} label={label} hint={f.hint} folder="document"
              max={f.maxFiles || 2} value={a.files || []} onChange={(v) => set(f.key, { files: v })} />
          );
        }
        if (f.kind === 'select' || f.kind === 'yesno') {
          const opts = f.kind === 'yesno' ? [{ v: 'yes', l: 'Yes' }, { v: 'no', l: 'No' }] : (f.options || []).map((o) => ({ v: o, l: o }));
          return (
            <div key={f.key} style={{ marginBottom: 14 }}>
              <label className="field-label">{label}</label>
              {f.hint ? <div className="t-tiny">{f.hint}</div> : null}
              <div className="row wrap" style={{ gap: 8, marginTop: 6 }}>
                {opts.map((o) => <Chip key={o.v} label={o.l} active={a.value === o.v} onClick={() => set(f.key, { value: o.v })} />)}
              </div>
            </div>
          );
        }
        return (
          <Input key={f.key} label={label} hint={f.hint} value={String(a.value ?? '')}
            type={f.kind === 'number' ? 'number' : f.kind === 'date' ? 'date' : 'text'}
            onChange={(e) => set(f.key, { value: e.target.value })} />
        );
      })}
    </div>
  );
};

export default OnboardingQuestions;
